import { render, staticRenderFns } from "./spuAdd.vue?vue&type=template&id=22c1cba2&scoped=true"
import script from "./spuAdd.vue?vue&type=script&lang=js"
export * from "./spuAdd.vue?vue&type=script&lang=js"
import style0 from "./spuAdd.vue?vue&type=style&index=0&id=22c1cba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1cba2",
  null
  
)

export default component.exports